import { useEffect, useState } from 'react'

export function useHandlerProgress(
  percentage: number,
  duration: number,
  onComplete?: () => void
) {
  const PROGRESS_INDICATOR_MIN_VALUE = 0
  const PROGRESS_INDICATOR_MAX_VALUE = 100

  const [currentPercentage, setCurrentPercentage] = useState(
    Math.min(
      Math.max(percentage, PROGRESS_INDICATOR_MIN_VALUE),
      PROGRESS_INDICATOR_MAX_VALUE
    )
  )

  useEffect(() => {
    setCurrentPercentage(
      Math.min(
        Math.max(percentage, PROGRESS_INDICATOR_MIN_VALUE),
        PROGRESS_INDICATOR_MAX_VALUE
      )
    )

    if (percentage === PROGRESS_INDICATOR_MAX_VALUE && onComplete) {
      onComplete()
    }
  }, [percentage, onComplete])

  useEffect(() => {
    if (duration) {
      const interval = duration / PROGRESS_INDICATOR_MAX_VALUE
      let progress = PROGRESS_INDICATOR_MIN_VALUE

      const intervalId = setInterval(() => {
        progress += 1
        setCurrentPercentage(prev =>
          Math.min(Math.max(prev + 1, 0), PROGRESS_INDICATOR_MAX_VALUE)
        )

        if (progress >= PROGRESS_INDICATOR_MAX_VALUE) {
          clearInterval(intervalId)
          onComplete?.()
        }
      }, interval)

      return () => clearInterval(intervalId)
    }
  }, [duration, onComplete])

  return {
    currentPercentage,
    PROGRESS_INDICATOR_MIN_VALUE,
    PROGRESS_INDICATOR_MAX_VALUE,
  }
}
